import React from 'react';
import {Toast, NavBar} from 'antd-mobile';
// import Quagga from 'quagga';
import Quagga from '@ericblade/quagga2';
import {changeMeta} from '../../common/Method.js';

import $ from '../../ajax/ajax';

import backImg from '../../assets/images/home/icon_dark_goBack.png';
import iconImage from '../../assets/images/home/icon_image.png';
import { createHashHistory } from 'history';

var streamLabelSelect = '' //手动修改摄像头
const history = createHashHistory();

function distance(p1, p2) {
    if (p1.x && p1.y && p2.x && p2.y) {
        let dx = Math.abs(p1.x - p2.x);
        let dy = Math.abs(p1.y - p2.y);

        return Math.sqrt(Math.pow(dx, 2) + Math.pow(dy, 2));
    }

    return 0.0;
}

function showMaxError(codes) {
    if (!codes) {
        return false;
    }

    let error = 0;
    // codes 最后一位为结束码，倒数第二位是校验码，这两个不参与校验码计算
    for (let j = 0; j < codes.length - 1; j++) {
        if (!!codes[j].error && error < codes[j].error) {
            error = codes[j].error;
        }
    }
    console.log(error);

    return error;
}

// function send(msg) {
//     $.post({
//         url: `/tsp/admin/menuLog/manage.do?c_addLog&menuId=errorCodeScan&url=` + msg,
//         showError: false,
//         guid: 'errorCodeScan'
//     });
// }

let ERROR_MAX = 0.1050;
let DIS_SCALE = 0.5;
class Scan extends React.Component {
    constructor(porps) {
        super(porps);
    }
    componentDidMount() {
        const max = this.getUrlParam("errorMax");
        if (!!max) {
            ERROR_MAX = max
        }
        const scale = this.getUrlParam("disScale");
        if (!!scale) {
            DIS_SCALE = scale
        }
        this.initQuagga();
        sessionStorage.setItem("barcodeHidden",'');
       
    }

    getUrlParam = (name) => {
        let reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)"); //构造一个含有目标参数的正则表达式对象
        let r = this.props.location.search.substr(1).match(reg); //匹配目标参数
        if (r != null) {
            return unescape(r[2]);
        }
        return undefined; //返回参数值
    };
    state = {
        inputStream: {
            type: "LiveStream",
            name:"Live",
            target: document.querySelector('#lineWrap') ,
            constraints: {
                width: {min: 640},
                height: {min: 480},
                facingMode: "environment",
                aspectRatio: {min: 1, max: 2},
            },
        },
        locator: {
            patchSize: "small",
            halfSample: true
        },
        numOfWorkers: 1,
        frequency: 10,
        decoder: {
            readers: [{
                format: "code_128_reader",
                config: {}
            }]
        },
        locate: false
    };

    initQuagga() {
        let _this = this;
        Quagga.init(_this.state, function(err) {
            if (err) {
                return Toast.fail(err);
            }
            _this.attachListeners();
            _this.checkCapabilities();
            Quagga.start();
            document.querySelector('#lineWrap').style.display = 'block';
        });
        Quagga.onProcessed(function(result) {

            // 正在识别，若识别到条形码（可能为识别成功），result 不为空
        });
        Quagga.onDetected(function(result) {
            // 识别成功
            let code = result.codeResult.code;
            if (!result && !result.codeResult) {
                Toast.hide();
                alert("Unrecognized, please provide correct Midea product barcode.");
            } 
            if (!_this.resultIsOk(result)) {
                alert('resultIsOk error')
                return;
            }

            // let maxError = showMaxError(result.codeResult.decodedCodes);
            // let msg = 'max_error:' + maxError + ', code:' + code;
            // if (ERROR_MAX < maxError) {
            //     console.log('ERROR_MAX < maxError')
            //     return;
            // }
            // if (0.0970 < maxError) {
            //     send(msg);
            // }
            document.querySelector('#lineWrap').style.display = 'none';
            let drawingCtx = Quagga.canvas.ctx.overlay;
            Quagga.ImageDebug.drawPath(result.box, {x: 0, y: 1}, drawingCtx, {color: "#00F", lineWidth: 2});
            Quagga.ImageDebug.drawPath(result.line, {x: 'x', y: 'y'}, drawingCtx, {color: 'red', lineWidth: 3});

            // Toast.loading(msg, 50000);

            _this.getMachineModelByBarCode(code);
        });
    }

    resultIsOk(result) {
        if (result.codeResult && result.codeResult.code && result.line) {
            if (!result.line[0]) {
                return false;
            }
            if (!result.line[1]) {
                return false;
            }

            // 检查扫描到的条形码是否够宽
            let x = result.line[0];
            let y = result.line[1];
            return window.screen.availWidth * DIS_SCALE <= distance(x, y);
        }

        return false;
    }

    //通过条码查询机器型号
    getMachineModelByBarCode(code) {

        Quagga.stop();
        let _this = this;

        sessionStorage.setItem("barcode", code);
        let productSerial = code.replace(/\s/g, '').substr(3, 8);
        $.get({
            url: `/tsp/api/v1/anonymity/product/serial/${productSerial}`,
            showError: true,
            guid: 'productSerial',
        }).then((res) => {
            Toast.hide();

            if (res.data.length) {
                sessionStorage.setItem("customerModel", res.data[0].customerModel);
                _this.handleScan(res.data[0].productId);
            } else {
                // todo log error msg
                Toast.fail('No product information for this product.', 3, () => {
                    _this.initQuagga();
                });
            }
        }).catch(() => {
            Toast.hide();
            _this.initQuagga();
        })
    }

    //处理扫码结果
    handleScan(productId) {
        productId && history.push(`/productDetail/${productId}`);
    }

    back(e) {
        history.goBack();
        e.stopPropagation(); // 阻止事件冒泡
    }
    goHome(e) {
        history.push("/");
        e.stopPropagation(); // 阻止事件冒泡
    }


    /*显示loading框*/
    loadingToast() {
        Toast.loading('Loading...', 50000, () => {
            console.log('Load complete !!!');
        }, true);
    }


    /*图片发生改变的时候*/
    change(e) {
        let _this = this;
        let file = e.target.files[0];
        if (!file) return;
        _this.loadingToast();
        let reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = function (data) {
            _this.scan(data.target.result)
        }
    }

    /*开始识别*/
    scan(data) {
        let _this = this;
        Quagga.decodeSingle({
            decoder: {
                readers: ["code_128_reader"] // List of active readers
            },
            locate: true, // try to locate the barcode in the image
            src: data // or 'data:image/jpg;base64,' + data
        }, function (result) {

            if (result && result.codeResult) {

                _this.getMachineModelbyBarCode2(result.codeResult.code) // 去搜索扫码结果
            } else {
                //第一次识别不到有可能是角度不对，需要旋转90度继续识别
                Toast.hide();
                alert("Unrecognized, please provide correct Midea product barcode.");


            }
        });
    }

    //通过条码查询机器型号
    getMachineModelbyBarCode2(data) {
        let _this = this;
        let productSerial = data.replace(/\s/g, '').substr(3, 8);
        $.get({
            url: `/tsp/api/v1/anonymity/product/serial/${productSerial}`,
            showError: true,
            guid: 'productSerial2',
        })
            .then((res) => {
                if (res.data.length) {
                    _this.hanldScan(res.data[0].productId)
                    sessionStorage.setItem("customerModel", res.data[0].customerModel);
                } else {
                    alert(' No product information for this product.')
                    Toast.hide();
                }

            })
            .catch(() => {
                Toast.hide();
            })
    }

    //处理扫码结果
    hanldScan(productId) {
        Toast.hide();
        productId && history.push(`/productDetail/${productId}`);
    }

    checkCapabilities() {
        let track = Quagga.CameraAccess.getActiveTrack();
        let capabilities = {};
        if (typeof track.getCapabilities === 'function') {
            capabilities = track.getCapabilities();
        }
        this.applyZoomSetting(capabilities.zoom);
    }

    updateOptionsForMediaRange(node, range) {
        while (node.firstChild) {
            node.removeChild(node.firstChild);
        }

        let NUM_STEPS = 6;
        let stepSize = (range.max - range.min) / NUM_STEPS;
        for (let i = 0; i <= NUM_STEPS; i++) {
            let value = range.min + (stepSize * i);
            let option = document.createElement('option');
            option.value = value;
            option.innerHTML = i + 1;
            node.appendChild(option);
        }
    }
   

    applyZoomSetting(capability) {
        if (window.MediaSettingsRange && capability instanceof window.MediaSettingsRange) {
            let node = document.querySelector('select[name="settings_zoom"]');
            if (node) {
                this.updateOptionsForMediaRange(node, capability);
                node.parentNode.style.display = 'block';
            }
        }
    }

    attachListeners() {
        let self = this;
        self.initCameraSelection();

        let zoomSelect = document.querySelector('select[name="settings_zoom"]');
        zoomSelect.onchange = function(e) {
            e.preventDefault();
            let value = e.target.value;

            self.applyZoom(value);
        };

        let cameraSelect = document.querySelector('select[name="input-stream_constraints"]');
        cameraSelect.onchange = function(e) {
            e.preventDefault();
            var value = e.target.value;
            var name = 'input-stream_constraints';
            var state = self._convertNameToState(name);
            console.log("**********Value of "+ state + " changed to " + value);
            self.setState(state, value);

        };
    }

    applyZoom(value) {
        let track = Quagga.CameraAccess.getActiveTrack();
        if (track && typeof track.getCapabilities === 'function') {
            return track.applyConstraints({advanced: [{zoom: parseFloat(value)}]});
        }
    }

    initCameraSelection(){
        var streamLabel = Quagga.CameraAccess.getActiveStreamLabel();

        console.log('-------getActiveStreamLabel   '+Quagga.CameraAccess.getActiveStreamLabel())
 
        return Quagga.CameraAccess.enumerateVideoDevices()
        .then(function(devices) {
            function pruneText(text) {
                return text.length > 30 ? text.substr(0, 30) : text;
            }
            var $deviceSelection = document.getElementById("deviceSelection");
            while ($deviceSelection.firstChild) {
                $deviceSelection.removeChild($deviceSelection.firstChild);
            }
            // devices.push({deviceId : '12', label : '12'})
            devices.forEach(function(device) {
                var $option = document.createElement("option");
                $option.value = device.deviceId || device.id;
                $option.appendChild(document.createTextNode(pruneText(device.label || device.deviceId || device.id)));
                $option.selected = streamLabel === device.label;
                $deviceSelection.appendChild($option);


            });
            console.log('-------getActiveStreamLabel------'+Quagga.CameraAccess.getActiveStreamLabel())

        });
    }
    _convertNameToState(name){
        return name.replace("_", ".").split("-").reduce(function(result, value) {
            return result + value.charAt(0).toUpperCase() + value.substring(1);
        });
    }
    setState(path,value) {
       
        var self = this;
        Quagga.stop();

        if (typeof self._accessByPath(self.inputMapper, path) === "function") {
            value = self._accessByPath(self.inputMapper, path)(value);
        }

        if (path.startsWith('settings.')) {
            var setting = path.substring(9);
            return self.applySetting(setting, value);
        }
        self._accessByPath(self.state, path, value);

        console.log('*********436state='+JSON.stringify(self.state));
        self.detachListeners();
        // Quagga.offDetected();
        // Quagga.offProcessed();
        self.initQuagga();
    }
    _accessByPath(obj,path,val) {
        var parts = path.split('.'),
            depth = parts.length,
            setter = (typeof val !== "undefined") ? true : false;

        return parts.reduce(function(o, key, i) {
            if (setter && (i + 1) === depth) {
                if (typeof o[key] === "object" && typeof val === "object") {
                    Object.assign(o[key], val);
                } else {
                    o[key] = val;
                }
            }
            return key in o ? o[key] : {};
        }, obj);
    }
    inputMapper = {
        inputStream: {
            constraints(value){
                if (/^(\d+)x(\d+)$/.test(value)) {
                    var values = value.split('x');
                    return {
                        width: {min: parseInt(values[0])},
                        height: {min: parseInt(values[1])}
                    };
                }
                return {
                    deviceId: value
                };
            }
        },
        numOfWorkers(value) {
            return parseInt(value);
        },
        decoder: {
            readers(value) {
                if (value === 'ean_extended') {
                    return [{
                        format: "ean_reader",
                        config: {
                            supplements: [
                                'ean_5_reader', 'ean_2_reader'
                            ]
                        }
                    }];
                }
                return [{
                    format: value + "_reader",
                    config: {}
                }];
            }
        }
    }
    detachListeners() {
        let cameraSelect = document.querySelector('select[name="input-stream_constraints"]');
        cameraSelect.onchange = null;
        // cameraSelect.remove();

        // $(".reader-config-group").off("change", "input, select");
    }

    render() {
        changeMeta(this.props.match.path );
        return (
            
            <div className="transition-item detail-page">
                <div  className="scanWrap" >
                    {/* <div style='width:100%;height:100%;border:solid 1px red' v-if="isPicker">123</div> */}

                    <div className="goback bg-f4f6f9">
                        <NavBar
                            mode="light"
                            icon={<img key="1" onClick={this.back}  src={backImg} width="24" height="24" alt="backImg" />}
                            onLeftClick={this.back}
                            rightContent={[<div><input type="file" accept=".png, .jpg, .jpeg" onChange={(e) => this.change(e)}  key="11" className="getFile"  alt="iconImage" /> <img key="22" src={iconImage} width="24" height="24" alt="iconImage" /> </div>]}
                        >
                        </NavBar>
                    </div>
                    <section id="scan-container" className="container">
                        <div id="interactive" className="viewport"></div>
                    </section>

                    <div className="scanText">
                        Align BarCode within frame to scan.
                        <br/>
                        <fieldset className="reader-config-group">
                            <label style={{width:'45%'}}>
                                <span>Camera</span>
                                <select name="input-stream_constraints" id="deviceSelection">
                                </select>
                            </label>
                            &nbsp;&nbsp;&nbsp;&nbsp;
                            <label style={{display: 'none',width:'45%'}}>
                                <span>Zoom</span>
                                <select name="settings_zoom"></select>
                            </label>
                        </fieldset>
                    </div>


                    <div className="maskWrap">
                        <div className="maskMain">
                            <div className="lineWrap" id="lineWrap">
                                <div className="line"></div>

                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}

export default Scan;



// WEBPACK FOOTER //
// ./src/pages/Home/scan.js